/**
 * Build-time config. Vite inlines `import.meta.env.VITE_*` at build, so each environment gets its
 * own bundle — staging-calc.huaca.io must never ship pointing at the prod API.
 */
const API_BASE = import.meta.env.VITE_API_BASE;

if (!API_BASE) {
  // Fail at boot, loudly. A missing API base otherwise surfaces as a pile of confusing fetch errors
  // against the app's own origin.
  throw new Error('VITE_API_BASE is not set — the app cannot reach the Huaca API.');
}

export const config = {
  apiBase: API_BASE as string,
  /** This module's own origin — logins and invites return HERE, not to a central app. */
  webOrigin: window.location.origin,
  productId: 'calculator',
  productName: 'מחשבון',
} as const;
